import React from "react";
import { Link } from "react-router-dom";

function Mantenimiento() {
    return (
        <div className="container min-vh-100 d-flex align-items-center justify-content-center py-5">
            <div className="row justify-content-center w-100">
                <div className="col-12 col-md-10 col-lg-8 text-center">
                    <img
                        src="https://zervicy.s3.us-east-1.amazonaws.com/imagenes/marca/zervicyazulhorizontal.png"
                        alt="Zervicy"
                        className="img-fluid mb-5"
                        style={{ maxWidth: "220px" }}
                    />

                    <h1 className="mb-3">Estamos trabajando para ti</h1>
                    <p className="text-muted mb-4">
                        Mientras tanto puedes ver nuestros enlaces importantes:
                    </p>

                    <div className="d-grid gap-3">
                        <Link to="/preguntas" className="btn btn-outline-primary btn-lg">
                            Preguntas frecuentes
                        </Link>
                        <Link to="/terminos" className="btn btn-outline-primary btn-lg">
                            Términos y condiciones
                        </Link>
                        <Link to="/politica-devolucion" className="btn btn-outline-primary btn-lg">
                            Política de devolución
                        </Link>
                        <Link to="/politica-privacidad" className="btn btn-outline-primary btn-lg">
                            Política de privacidad
                        </Link>
                        <Link to="/politica-cookies" className="btn btn-outline-primary btn-lg">
                            Política de cookies
                        </Link>
                         <Link to="/eliminar-datos" className="btn btn-outline-primary btn-lg">
                            Eliminar datos
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Mantenimiento;